import React from 'react';
import Heading from 'components/atoms/Heading/Heading';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import Txt from 'components/atoms/Txt/Txt';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import { CASHBACK, GAMING, SURVEY_TIPS } from 'components/pages/pages';
import Script from 'next/script';
import Trustpilot from 'components/molecules/Trustpilot/Trustpilot';
import A from 'components/atoms/A/A';
import LocaleAwareImage from 'components/atoms/LocaleAwareImage/LocaleAwareImage';

export interface Props {}

const HowItWorks: React.FC<Props> = () => {
  return (
    <main>
      <Script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      />

      <SplitRow
        mobileColumnOrderSwapped
        isFirstRow
        leftColumn={
          <>
            <Heading level={1}>How do paid surveys work?</Heading>
            <Heading level={2}>What is a paid survey site?</Heading>
            <Txt component="p">
              Paid surveys are a fast and convenient side hustle for students, parents, or anyone
              who wants to add a little extra money into their account!
            </Txt>
            <Txt component="p">
              To get started, you just need to answer a few simple questions about yourself -
              you&apos;ll then start being matched with paid surveys that are right for you. After
              completing surveys, you&apos;ll receive cash rewards for the time spent sharing your
              opinions!
            </Txt>
            <Txt component="p">
              It&apos;s super easy to get started - you&apos;ll be getting your voice heard (whilst
              topping up your piggy bank!) in no time.
            </Txt>
          </>
        }
        rightColumn={
          <LocaleAwareImage
            src="/assets/how_it_works_img_1.png"
            alt="What is a paid survey site?"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Heading level={2}>How to make money online with paid surveys?</Heading>
            <Txt component="p">
              Qmee is a free browser site and mobile app where you can earn real money for taking
              paid surveys. With no investment beforehand, you just need to tell us a bit about
              yourself to start being matched with surveys on Qmee.
            </Txt>
            <Txt component="p">
              With the Qmee mobile app, you can take surveys for cash anytime, anywhere - earn cash
              online from your phone, or make money whilst relaxing at home! Share your opinions
              with fun and engaging online surveys, and you&apos;ll get a cash reward for each one
              you complete.
            </Txt>
          </>
        }
        leftColumn={
          <LocaleAwareImage
            src="/assets/how_it_works_img_2.png"
            alt="How to make money online with paid surveys?"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Heading level={2}>Does Qmee have a minimum withdrawal amount?</Heading>
            <Txt component="p">
              The simple answer? No! There&apos;s no minimum withdrawal amount with Qmee.
            </Txt>
            <Txt component="p">
              When you complete surveys, Qmee adds your rewards to your piggy bank in real time. One
              of our top rated features is that you can withdraw your earnings at any time - meaning
              you&apos;re always in control of your rewards!
            </Txt>
            <Txt component="p">
              A no minimum cashout amount isn&apos;t something that all paid survey sites have,
              making Qmee one of the best ways to make money online!
            </Txt>
          </>
        }
        rightColumn={
          <LocaleAwareImage
            src="/assets/how_it_works_img_3.png"
            alt="Does Qmee have a minimum withdrawal amount?"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Heading level={2}>Is Qmee a legit way to make money online?</Heading>
            <Txt component="p">
              Sharing your opinion and influencing your favorite brands, by taking paid surveys with
              Qmee, is one of the best legitimate ways to make money online in 2023. But, you
              don&apos;t have to take our word for it! Read some of our user stories to see what
              other people think. We&apos;re also rated highly on review sites.
            </Txt>

            <Trustpilot showSmallWidget />
          </>
        }
        leftColumn={
          <LocaleAwareImage
            src="/assets/how_it_works_img_4.png"
            alt="Is Qmee a legit way to make money online?"
            width={500}
            height={400}
          />
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Heading level={2}>How can I earn cash without taking paid surveys?</Heading>
            <Txt component="p">
              Qmee not only has surveys - earn cash and free gift cards online with our{' '}
              <A href={CASHBACK.path}>cashback offers!</A> Our hand-picked money earners help you
              earn real cash from home by purchasing things you were going to buy anyway. It&apos;s
              a win-win situation!
            </Txt>
            <Txt component="p">
              With Qmee, you can also make money by <A href={GAMING.path}>playing games online</A>.
              It&apos;s a super easy and fast way to earn money from your phone without paying
              anything - just download the game and get paid to play!
            </Txt>
            <Txt component="p">
              Earn extra cash when searching online too! Add the Qmee app to your desktop browser to
              start earning money online when you search for your favorite sites and engage with the
              hottest brands!
            </Txt>
            <Txt component="p">
              With no minimum cashout amount, you can start making quick, easy money by signing up
              today!
            </Txt>
          </>
        }
        rightColumn={
          <LocaleAwareImage
            src="/assets/how_it_works_img_5.png"
            alt="How can I earn cash without taking paid surveys?"
            width={500}
            height={400}
          />
        }
      />

      <FullWidthCta title={<Txt>Survey Tips</Txt>} ctaText="View Tips" ctaLink={SURVEY_TIPS.path}>
        Check out some of the handy tips that can help with your survey experience.
      </FullWidthCta>
    </main>
  );
};

export default HowItWorks;
